import React, { Component } from 'react'
import { inject } from 'mobx-react'
import PropTypes from 'prop-types'
import findIndex from 'lodash/findIndex'
import differenceBy from 'lodash/differenceBy'

import Spinner from '@components/spinner'
import PlusIcon from '@components/Icon/PlusIcon'

import GetContactInfo from '../GetContactInfo'

class GetContactInfoSection extends Component {
  static propTypes = {
    form: PropTypes.object,
    show: PropTypes.bool,
    staticData: PropTypes.object,
    growlStore: PropTypes.object
  }

  state = {
    addedPhones: [],
    addedEmails: []
  }

  handlePhoneClick = phone => {
    const { form } = this.props
    const { addedPhones } = this.state
    const { phoneNum, phoneTypeId } = phone
    const { phones } = form.values.address

    let insertIndex = findIndex(phones, ({ phoneNum }) => !phoneNum)

    insertIndex = insertIndex >= 0 ? insertIndex : phones.length

    const phoneTypeIdPath = `address.phones[${insertIndex}].phoneTypeId`
    const phoneNumPath = `address.phones[${insertIndex}].phoneNum`

    form.setFieldValue(phoneTypeIdPath, phoneTypeId, false)
    form.setFieldValue(phoneNumPath, phoneNum, false)

    form.setFieldTouched(phoneTypeIdPath, true)
    form.setFieldTouched(phoneNumPath, true)

    this.setState({
      addedPhones: [...addedPhones, phone]
    })
  }

  handleEmailClick = emailAddress => {
    const { form } = this.props
    const { addedEmails } = this.state
    const { email } = emailAddress
    const { emails } = form.values.address

    let insertIndex = findIndex(emails, ({ email }) => !email)

    insertIndex = insertIndex >= 0 ? insertIndex : emails.length

    const emailPath = form.values.email
      ? `address.emails[${insertIndex}].email`
      : 'email'

    form.setFieldValue(emailPath, email, false)

    form.setFieldTouched(emailPath, true)

    this.setState({
      addedEmails: [...addedEmails, emailAddress]
    })
  }

  renderEmailAddressPicker = (emailAddresses, emailToString) => {
    emailAddresses = differenceBy(
      emailAddresses,
      this.state.addedEmails,
      emailToString
    )

    if (!emailAddresses.length) {
      return <span className='text-gray'>No email addresses available</span>
    }

    return (
      <div>
        {emailAddresses.map(email => (
          <ContactInfoEntry
            key={emailToString(email)}
            item={email}
            itemToString={emailToString}
            onClick={this.handleEmailClick}
          />
        ))}
      </div>
    )
  }

  renderPhoneNumberPicker = (phoneNumbers, phoneToString) => {
    phoneNumbers = differenceBy(
      phoneNumbers,
      this.state.addedPhones,
      phoneToString
    )

    if (!phoneNumbers.length) {
      return <span className='text-gray'>No phone numbers available</span>
    }

    return (
      <div>
        {phoneNumbers.map(phone => (
          <ContactInfoEntry
            key={phoneToString(phone)}
            item={phone}
            itemToString={phoneToString}
            onClick={this.handlePhoneClick}
          />
        ))}
      </div>
    )
  }

  render () {
    const { form, show, staticData, growlStore } = this.props

    if (!show) return null

    return (
      <div className='get-contact-info-form-section'>
        <GetContactInfo
          expert={form.values}
          staticData={staticData}
          onError={err => growlStore.showError(err)}
        >
          {({
            loading,
            phoneNumbers,
            emailAddresses,
            phoneToString,
            emailToString
          }) => {
            if (loading) return <Spinner />
            return (
              <div className='contact-info-picker'>
                <div className='contact-info-picker__section'>
                  <h2 className='contact-info-picker__section-title'>
                    Phone numbers
                  </h2>
                  {this.renderPhoneNumberPicker(phoneNumbers, phoneToString)}
                </div>
                <div className='contact-info-picker__section'>
                  <h2 className='contact-info-picker__section-title'>
                    Email addresses
                  </h2>
                  {this.renderEmailAddressPicker(emailAddresses, emailToString)}
                </div>
              </div>
            )
          }}
        </GetContactInfo>
      </div>
    )
  }
}

function ContactInfoEntry ({ item, itemToString, onClick }) {
  return (
    <div key={itemToString(item)} className='contact-info-picker__entry'>
      <PlusIcon onClick={() => onClick(item)} />
      <span>{itemToString(item)}</span>
    </div>
  )
}

ContactInfoEntry.propTypes = {
  item: PropTypes.object,
  itemToString: PropTypes.func,
  onClick: PropTypes.func
}

export default inject('staticData', 'growlStore')(GetContactInfoSection)
